import React, { useState , useEffect} from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import AOS from 'aos'
import 'aos/dist/aos.css'

const Benefit = React.forwardRef((props, ref) => {
    const [isHovered, setIsHovered] = useState(null);
    const [serviceCard, setServiceCard] = useState([
        {
            Image: '/fexperience/assets/icon/01-Services_MB.png',
            Heading: 'Market Better',
            servicePointOnePara:'Promote your products in a whole new way. Market better with dynamic strategies that captivate and convert!'
        },
        {
            Image: '/fexperience/assets/icon/02-Services-EE.png',
            Heading: 'Easy to Explain',
            servicePointOnePara:'Support your non-technical customers with 3D presentations to give them visual context and help them understand your products & their use.'
        },
        {
            Image: '/fexperience/assets/icon/03-Services-CF.png',
            Heading: 'Convince Faster',
            servicePointOnePara:'Help your customers to step inside your product with the help of rich spatial presentation, boosting their knowledge and confidence.'
        },
        {
            Image: '/fexperience/assets/icon/04-Services_S.png',
            Heading: 'Sell More',
            servicePointOnePara:'Convert more of your leads into customers and close 2X deals by spotlighting all the designs and features, ensuring your brand stands out.',
        },
        {
            Image: '/fexperience/assets/icon/05-Services-SD.png',
            Heading: 'Secured Data',
            servicePointOnePara:'Reduce the risk of uncertainty and data loss by safeguarding your data with the highest levels of security and peace of mind. ',
        },
        {
            Image: '/fexperience/assets/icon/06-Services-SCC.png',
            Heading: 'Save Cost on Collateral',
            servicePointOnePara:'Maximize substantial savings on collateral using spatial computing, enhancing efficiency without compromising quality.',
        },
    ])

    useEffect(()=>{
        AOS.init({duration:2000})
    });

    return (
        <>
            <div className="ServiceContainer mb-5" ref={ref}>
                <div className="ServiceContent  mb-4" data-aos="fade-up">
                    <Container>
                        <h1 className='text-center mt-3 mb-2 fontWeight-800' style={{
                            color: '#0F75D6'
                        }}>Benefits</h1>
                        <h5>FXperience, helpful in all the right ways, transforming ordinary into extraordinary with immersive, interactive solutions.</h5>
                        <Row style={{
                            justifyContent: 'center'
                        }}>
                            {serviceCard.map((service, serviceIndex) => (
                                <Col md={4} sm={12} key={serviceIndex} style={{
                                    position: 'relative',
                                    margin:'20px 0px'
                                }}>
                                    <div
                                        className={`ServiceCardOne cursor-pointer ${isHovered === serviceIndex ? 'hovered scaleText' : ''}`}
                                        onMouseEnter={() => setIsHovered(serviceIndex)}
                                        onMouseLeave={() => setIsHovered(null)}
                                    >
                                        <Stack direction='vertical' gap={2} style={{ justifyContent: 'center' }}>
                                            <img src={service.Image} alt="" className='img-fluid serviceIcon mx-auto' />
                                            <h4 style={{ color: '#000' }}>{service.Heading}</h4>
                                            <div className={`CardBodyText02 loremText pt-0 ${isHovered === serviceIndex ? 'visibleText' : 'displayNone'}`}>
                                                <ul>
                                                    <li style={{
                                                        listStyle: 'none'
                                                    }}>
                                                        <Stack direction='vertical' gap={2}>
                                                            <div className="servicePoints">
                                                                <h6 style={{color:'#0F75D6', fontWeight:'bolder'}}>{service.servicePointOne}</h6>
                                                                <p style={{fontSize:'14px', color:'#6a6a6a', marginBottom:'0px'}}>{service.servicePointOnePara}</p>
                                                            </div>
                                                        </Stack>
                                                    </li>
                                                </ul>
                                            </div>
                                        </Stack>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
});

export default Benefit
